import React from 'react';
import styles from './CaseTaskItem.module.scss';
import { useNavigate } from 'react-router-dom';
import { useNotificationStore } from '@/store/NotificationStore';
import WebApp from '@twa-dev/sdk';
import friendsIcon from "../../assets/friendsIconDaily.png"
import tasksIcon from "../../assets/taskIconDaily.png"
import { getMessage, recordSendProgress } from '@/api/modules/Case/case';

const CaseTaskItem = ({ 
  task, 
  safe_event_id, 
  onTaskUpdate 
}: { 
  task: any; 
  safe_event_id: string; 
  onTaskUpdate?: (taskId: number, updatedTask: any) => void;
}) => {
  const navigate = useNavigate();
  const current = task.user_progress ?? 0;
  const total = task.target_progress ?? 1;
  const percent = Math.min(100, Math.max(0, (current / total) * 100));
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );

  // Определяем иконку в зависимости от id задачи
  const taskIcon = task.id === 15 ?   tasksIcon : friendsIcon;
  const tg = window?.Telegram?.WebApp;
  const handleFriendsTask = async () => {
    try {
      if (task.id === 16) {
        try {
          const res = await getMessage('safe');
          console.log(res.message_id, 'res');
          tg?.shareMessage(res.message_id, async (result:boolean) => {
            if (result === true) {
              try {
                console.log(task,"SSSSSD")
                const updatedData = await recordSendProgress(safe_event_id, task.id);
                console.log(updatedData, 'ss22');

                // Обновляем прогресс задачи
                if (updatedData?.task && onTaskUpdate) {
                  onTaskUpdate(task.id, updatedData.task);
                }
              } catch (error) {
                console.error('Ошибка при записи прогресса задания:', error);
              }
            }
          });
        } catch (error) {
          console.error('Ошибка при получении сообщения:', error);
        }
        return;
      }

    
    } catch (error) {
      console.error('Ошибка при выполнении задания:', error);
    }
  };

  if (task.type !== 'complete-tasks-safe') {
    return (
      <div className={styles.caseTaskItem}>
        <div className={styles.progressWrapper}>
          <div className={styles.progressBar}>
            <div
              className={styles.progressFill}
              style={{ width: `${percent}%` }}
            />
          </div>
          <div className={styles.progressText}>
            {current}/{total}
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.contentLeft}>
            <div className={styles.taskIconContainer}>
              <img src={taskIcon} alt="Task icon" className={styles.taskIcon} />
            </div>
            <div className={styles.title}>{task.view_details.title}</div>
          </div>

          {task.status === 'claim' ? (
            <div className={styles.done}>Выполнено ✓</div>
          ) : (
            <button onClick={handleFriendsTask} className={styles.button}>
              Отправить
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.caseTaskItem}>
      <div className={styles.progressWrapper}>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ width: `${percent}%` }}
          />
        </div>
        <div className={styles.progressText}>
          {current}/{total}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.contentLeft}>
          <div className={styles.taskIconContainer}>
            <img src={taskIcon} alt="Task icon" className={styles.taskIcon} />
          </div>
          <div className={styles.title}>{task.view_details.title}</div>
        </div>
        {task.status === 'claim' ? (
          <div className={styles.done}>Выполнено ✓</div>
        ) : (
          <button
            onClick={() => {
              navigate(`/tasks`);
            }}
            className={styles.button}
          >
            Перейти
          </button>
        )}
      </div>
    </div>
  );
};

export default CaseTaskItem;

